export default __webpack_public_path__ + "8f2b8677a7107d0ad5f1c8cb4c8cc3bc.svg";